module.exports = __webpack_public_path__ + "img/icon_instagram_pencil.b64290c5.svg";